import type { TimeSpeedInputs, TimeSpeedMode, TimeSpeedResult } from "./types";

export function calculateTimeSpeed(mode: TimeSpeedMode, inputs: TimeSpeedInputs): TimeSpeedResult {
  const travelSpeed = mode === "travelSpeed" && inputs.duration > 0 ? (inputs.weldLength / inputs.duration) * 60 : inputs.travelSpeed;
  const duration = mode === "duration" && inputs.travelSpeed > 0 ? (inputs.weldLength / inputs.travelSpeed) * 60 : inputs.duration;

  return {
    travelSpeed,
    duration,
    durationMinutes: duration / 60,
    lengthPerSecond: duration > 0 ? inputs.weldLength / duration : 0
  };
}
